import { render, staticRenderFns } from "./DepartmentIndex.vue?vue&type=template&id=5c83cd75&scoped=true&"
import script from "./DepartmentIndex.vue?vue&type=script&lang=js&"
export * from "./DepartmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentIndex.vue?vue&type=style&index=0&id=5c83cd75&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83cd75",
  null
  
)

export default component.exports